import React from 'react';
import PictureTalk2023 from 'views/PictureTalk2023';

const AccountGeneralPage = () => {
  return <PictureTalk2023 />;
};

export default AccountGeneralPage;
